import { SAVE_CUSTOMER_LIST } from '../actions/customer';

const defaultState = {
  customers: [],
};

const saveCustomerList = (state, customerList) => {
  if (!customerList) {
    return state;
  }

  return {
    ...state,
    customers: customerList,
  };
};

export default (state = defaultState, action) => {
  const { type } = action;

  switch (type) {
    case SAVE_CUSTOMER_LIST: {
      const { customerList } = action;
      return saveCustomerList(state, customerList);
    }
    default: {
      return state;
    }
  }
};
